// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth, onAuthStateChanged } from "firebase/auth"; // Add Firebase Auth
import { getFirestore, initializeFirestore, setLogLevel } from "firebase/firestore"; // Add Firestore (if needed)
import { getFunctions, connectFunctionsEmulator } from 'firebase/functions';

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyAoW1hKD3Xf7MyjuZshi8ZP4BxjbAEyvR0",
  authDomain: "apple-schedule-app.firebaseapp.com",
  projectId: "apple-schedule-app",
  storageBucket: "apple-schedule-app.firebasestorage.app",
  messagingSenderId: "376877322632",
  appId: "1:376877322632:web:5c26995113a96b4a336a3d",
  measurementId: "G-PCVGWNC1QM"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
const auth = getAuth(app); // Firebase Authentication instance
// Initialize Firestore with safer transport options in dev to avoid fetch-stream/CORS issues
let db;
let functions;
// Auth-ready promise placeholders (hoisted so helpers can access them even if try block fails)
let _authReady = Promise.resolve(null);
let _authReadyResolve = null;
try {
  if (typeof initializeFirestore === 'function') {
    // Force long-polling and disable fetch streams to avoid environments where fetch stream
    // transport can fail CORS checks (observed in some local setups/proxies).
    db = initializeFirestore(app, { experimentalForceLongPolling: true, useFetchStreams: false });
  } else {
    db = getFirestore(app);
  }
} catch (e) {
  // Fallback to default getter if initialize fails
  db = getFirestore(app);
}

try {
  // Use explicit region to match where your callable functions are deployed.
  // If you deploy to a different region, change the second argument below.
  functions = getFunctions(app, 'us-central1');
  // Auto-connect to emulator when explicitly enabled via environment variables.
  // Use REACT_APP_USE_FUNCTIONS_EMULATOR=true to enable and optionally
  // REACT_APP_FUNCTIONS_EMULATOR_HOST / REACT_APP_FUNCTIONS_EMULATOR_PORT to override host/port.
  try {
    const useEmu = (typeof process !== 'undefined' && process.env && process.env.REACT_APP_USE_FUNCTIONS_EMULATOR) || (typeof window !== 'undefined' && window?.REACT_APP_USE_FUNCTIONS_EMULATOR);
    if (useEmu) {
      const host = (process && process.env && process.env.REACT_APP_FUNCTIONS_EMULATOR_HOST) || (window && window.REACT_APP_FUNCTIONS_EMULATOR_HOST) || 'localhost';
      const port = parseInt((process && process.env && process.env.REACT_APP_FUNCTIONS_EMULATOR_PORT) || (window && window.REACT_APP_FUNCTIONS_EMULATOR_PORT) || '5001', 10);
      try {
        connectFunctionsEmulator(functions, host, port);
  // eslint-disable-next-line no-console
  if (process.env.NODE_ENV !== 'production') console.info(`[firebase] connected functions emulator on ${host}:${port}`);
      } catch (e) {
        // eslint-disable-next-line no-console
        console.warn('[firebase] failed to connect functions emulator', e?.message || e);
      }
    }
  } catch (e) {
    // ignore env lookups in non-Node environments
  }
} catch (e) {
  // ignore — functions export may not be used in all environments
  functions = null;
}

// Enable debug logging for Firestore to help surface Listen/Fetch errors in DevTools
try {
  // setLogLevel is available in the modular Firestore SDK and accepts: 'debug'|'error'|'silent'
  setLogLevel?.('debug');
  // Create a promise that resolves on the first auth state event so other modules
  // can await initial auth readiness and avoid attaching listeners too early.
  _authReady = new Promise((resolve) => { _authReadyResolve = resolve; });

  // Single auth observer: log transitions and resolve the initial-ready promise.
  onAuthStateChanged(auth, (user) => {
  // eslint-disable-next-line no-console
  if (process.env.NODE_ENV !== 'production') console.info('[firebase] auth state changed - uid:', user ? user.uid : null);
    try { _authReadyResolve?.(user); } catch (e) { /* ignore */ }
    // keep the observer active for future auth events; do not unsub here
  });
  // keep the observer active for future auth events; do not unsub here
} catch (e) {
  // eslint-disable-next-line no-console
  if (process.env.NODE_ENV !== 'production') console.warn('[firebase] failed to enable firestore debug logging', e?.message || e);
}

// Export the services so they can be used in other parts of your app
// Export helper that other modules can await
function waitForAuthReady() { return _authReady; }

export { app, auth, db, functions, waitForAuthReady };
